import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { get, post, patch, del } from '../../api/api';

export const listarErps = async () => {
  return await get<IRespostaFuncao<any[]>>('/erps');
};

export const criarErp = async (payload: { nome: string; versoes?: { versao: string }[] }) => {
  return await post<IRespostaFuncao<any>>('/erps/cria-erp', payload);
};

export const atualizarErp = async (id: string, payload: { nome?: string; versoes?: { id?: string; versao: string }[] }) => {
  return await patch<IRespostaFuncao<any>>(`/erps/${id}/atualiza-erp`, payload);
};

export const adicionarVersaoErp = async (id: string, versao: string) => {
  return await patch<IRespostaFuncao<any>>(`/erps/${id}/adiciona-versao`, { versao });
};

export const removerErp = async (id: string) => {
  return await del<IRespostaFuncao<any>>(`/erps/${id}/remove-erp`);
};
